var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -2734)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 2734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.361 2746.296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.4,258.272c4.695,0,8.5-3.487,8.5-13.29a8.5,8.5,0,0,0-17,0C150.9,254.785,154.7,258.272,159.4,258.272Z",
    transform: "translate(-78.757 -217.357)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,316.556a.966.966,0,0,0-1.216.806,9.024,9.024,0,0,0-.078,1.186c0,4.7.87,8.274,2.585,10.612a8.06,8.06,0,0,0,12.815,0,11.832,11.832,0,0,0,1.773-3.8C157.979,320.5,150.266,317.712,146.1,316.556Z",
    transform: "translate(-73.163 -290.922)",
    fill: "#176eb5",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(88.869 10.884)",
    fill: "#ffbf9e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(65.209 10.884)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.691,47.861a11.716,11.716,0,0,0-23.408,0c0,6.183,5.24,10.336,11.7,10.336S134.691,54.043,134.691,47.861Z",
    transform: "translate(-42.348 -33.701)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.207,68.336C114.444,66,114.965,53.3,118.268,48.389a11.191,11.191,0,0,0-6.985,10.247c0,6.183,5.24,10.336,11.7,10.336A13.993,13.993,0,0,0,127.207,68.336Z",
    transform: "translate(-42.348 -44.476)",
    fill: "#ffbf9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.407,168.224a2.174,2.174,0,0,1-1.639-.746.607.607,0,1,1,.915-.8.96.96,0,0,0,1.45,0,.607.607,0,1,1,.915.8A2.174,2.174,0,0,1,175.407,168.224Z",
    transform: "translate(-99.641 -153.009)",
    fill: "#4e5660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.937,168.224a2.174,2.174,0,0,1-1.639-.746.607.607,0,1,1,.915-.8.96.96,0,0,0,1.45,0,.607.607,0,1,1,.915.8A2.174,2.174,0,0,1,295.937,168.224Z",
    transform: "translate(-210.424 -153.009)",
    fill: "#4e5660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.527,182.845a.916.916,0,1,0-.914.975A.946.946,0,0,0,246.527,182.845Z",
    transform: "translate(-164.974 -167.161)",
    fill: "#4e5660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.824,357.823c1.529-2.085,2.386-5.15,2.554-9.124a.951.951,0,0,0-1.164-.968,38.847,38.847,0,0,0-15.5,7.695,10.7,10.7,0,0,0,1.3,2.4,8.06,8.06,0,0,0,12.815,0Z",
    transform: "translate(-87.777 -319.585)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.389 28.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.753,359.285a.6.6,0,0,1-.429-.178l-.429-.429a.607.607,0,0,1,.858-.858l.429.429a.606.606,0,0,1-.429,1.035Z",
    transform: "translate(-178.717 -357.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.278,438.55a.607.607,0,0,1-.429-1.035l.5-.5a.607.607,0,0,1,.858.858l-.5.5A.6.6,0,0,1,219.278,438.55Z",
    transform: "translate(-215.44 -430.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.342,438.6a.6.6,0,0,1-.429-.178l-.493-.493a.607.607,0,1,1,.858-.858l.493.493a.607.607,0,0,1-.429,1.035Z",
    transform: "translate(-276.627 -430.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.332,390.785a.606.606,0,0,1-.429-1.035l.415-.415a.607.607,0,1,1,.858.858l-.415.415A.6.6,0,0,1,305.332,390.785Z",
    transform: "translate(-294.534 -386.608)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.763,322.08a.607.607,0,0,1-.429-1.036l.152-.152a.607.607,0,1,1,.858.858l-.152.152A.6.6,0,0,1,295.763,322.08Z",
    transform: "translate(-211.35 -294.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.521,5.931A3.231,3.231,0,0,1,232.294,2.7,2.706,2.706,0,0,1,235,0a.607.607,0,1,1,0,1.213,1.492,1.492,0,0,0-1.49,1.49,2.017,2.017,0,0,0,2.014,2.014.607.607,0,1,1,0,1.213Z",
    transform: "translate(-153.572)",
    fill: "#4e5660"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby2);
export default __webpack_public_path__ + "static/media/baby2.45a087b68eb622dce4804deb5981535b.svg";
export { ForwardRef as ReactComponent };